import InlineFormInput from "../../FormGroups/InlineFormInput";

export default function Edit({ command, commandIdx, control, errors }) {
    return (
        <>
            <InlineFormInput
                name={`commands.${commandIdx}.settings.x`}
                control={control}
                defaultValue={command.settings?.x || ""}
                errors={errors?.commands?.[commandIdx]?.settings?.x}
                placeholder="x"
                inputType="text"
                unit="m"
            />

            <InlineFormInput
                name={`commands.${commandIdx}.settings.y`}
                control={control}
                defaultValue={command.settings?.y || ""}
                errors={errors?.commands?.[commandIdx]?.settings?.y}
                placeholder="y"
                inputType="text"
                unit="m"
            />
        </>
    );
}
